import { Card, Col, Edit, Form, Input, ListButton, Row, Space, useForm } from '@pankod/refine-antd';
import { useUniqueValidator } from 'hooks/useUniqueValidator';
import { IWarehouse } from 'interfaces';
import { checkWarehouseNameUnique } from 'services/warehouse';
import { removeEmptyObject } from 'utilities/shared';

export const WarehouseEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<IWarehouse>({
    metaData: {
      fields: [
        'id',
        'name',
        'email',
        'warehouseCode',
        'mobileNumber',
        {
          address: ['street', 'area', 'city', 'country', 'zip'],
        },
      ],
    },
  });
  const originalName = queryResult?.data?.data?.name;

  const validateWarehouseName = useUniqueValidator({
    originalValue: originalName,
    checkUnique: checkWarehouseNameUnique,
    errorMessage: 'Warehouse name already exists',
  });

  return (
    <Edit
      isLoading={queryResult?.isFetching}
      saveButtonProps={saveButtonProps}
      headerProps={{ extra: <ListButton /> }}
    >
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          isActive: true,
          ...formProps.initialValues,
        }}
        onFinish={(values) => {
          removeEmptyObject(values, 'address');
          formProps?.onFinish?.(values); // call refine's original submit
        }}
      >
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Warehouse Name"
              name="name"
              validateTrigger="onChange"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Warehouse name is required',
                },
                { validator: validateWarehouseName },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Email"
              name="email"
              // rules={[
              //   {
              //     required: true,
              //     type: 'email',
              //   },
              // ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Mobile Number"
              name="mobileNumber"
              rules={[
                // {
                //   required: true,
                // },
                {
                  pattern: /^(\+\d{1,3}[- ]?)?\d{8,12}$/,
                  message: 'Provide valid number',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Unique ID"
              name="warehouseCode"
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <Input disabled />
            </Form.Item>
            <Card title="Address">
              <Space align="center" size="large" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item
                  label="Street"
                  name={['address', 'street']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Area"
                  name={['address', 'area']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
              </Space>
              <Space align="center" size="large" style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item
                  label="City"
                  name={['address', 'city']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Country"
                  name={['address', 'country']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
              </Space>
              <Space align="center" size="large" style={{ display: 'flex' }}>
                <Form.Item
                  label="Zip"
                  name={['address', 'zip']}
                  // rules={[
                  //   {
                  //     required: true,
                  //   },
                  // ]}
                >
                  <Input />
                </Form.Item>
              </Space>
            </Card>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
